// removed by extract-text-webpack-plugin
module.exports = {"job-list":"_9myTPJmx","jobList":"_9myTPJmx","job":"_1W22Bhu6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/JobList/JobList.pcss
// module id = 1005
// module chunks = 0